import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth.js'
import { useSelectionStore } from '@/stores/selection.js'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { public: true },
  },
  {
    path: '/selecionar',
    name: 'selecionar',
    component: () => import('@/views/SelectionView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { requiresAuth: true, requiresTerminal: true },
  },
  {
    path: '/inventario',
    name: 'inventario',
    component: () => import('@/views/InventoryView.vue'),
    meta: { requiresAuth: true, requiresTerminal: true },
  },
  {
    path: '/historico',
    name: 'historico',
    component: () => import('@/views/HistoryView.vue'),
    meta: { requiresAuth: true, requiresTerminal: true },
  },
  {
    path: '/pagamento',
    name: 'pagamento',
    component: () => import('@/views/payment/PaymentView.vue'),
    meta: { requiresAuth: true, requiresTerminal: true },
  },
  {
    path: '/saida',
    name: 'saida',
    component: () => import('@/views/cashout/CashoutView.vue'),
    meta: { requiresAuth: true, requiresTerminal: true },
  },
  {
    path: '/carregamento',
    name: 'carregamento',
    component: () => import('@/views/replenishment/CarregamentoView.vue'),
    meta: { requiresAuth: true, requiresTerminal: true },
  },
  {
    path: '/descarga',
    name: 'descarga',
    component: () => import('@/views/descarga/DescargaView.vue'),
    meta: { requiresAuth: true, requiresTerminal: true },
  },
  {
    path: '/destrocar',
    name: 'destrocar',
    component: () => import('@/views/destrocar/DestrocarView.vue'),
    meta: { requiresAuth: true, requiresTerminal: true },
  },
  {
    path: '/retirar-cofre',
    name: 'retirar-cofre',
    component: () => import('@/views/safe/RetirarCofreView.vue'),
    meta: { requiresAuth: true, requiresTerminal: true },
  },
  {
    path: '/fundo-caixa',
    name: 'fundo-caixa',
    component: () => import('@/views/cashfund/FundoCaixaView.vue'),
    meta: { requiresAuth: true, requiresTerminal: true },
  },
  {
    path: '/fechar-caixa',
    name: 'fechar-caixa',
    component: () => import('@/views/fechar/FecharCaixaView.vue'),
    meta: { requiresAuth: true, requiresTerminal: true },
  },
  // TODO Etapa 4: rotas de terminal (outras ações)
  // TODO Etapa 7: área de administração
  {
    path: '/',
    redirect: '/selecionar',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to) => {
  const auth      = useAuthStore()
  const selection = useSelectionStore()

  // Aguarda carregamento inicial da sessão
  if (auth.loading) {
    await new Promise(resolve => {
      const stop = setInterval(() => {
        if (!auth.loading) { clearInterval(stop); resolve() }
      }, 50)
    })
  }

  if (to.meta.requiresAuth && !auth.isLoggedIn) {
    return { name: 'login' }
  }

  if (to.meta.requiresTerminal && !selection.hasSelection) {
    return { name: 'selecionar' }
  }

  if (to.meta.requiresRole && auth.user?.role !== to.meta.requiresRole) {
    return { name: 'selecionar' }
  }

  if (to.name === 'login' && auth.isLoggedIn) {
    return { name: 'selecionar' }
  }
})

// Redireciona para login quando sessão expira (evento disparado pelo interceptor axios)
window.addEventListener('auth:expired', () => {
  const auth      = useAuthStore()
  const selection = useSelectionStore()
  auth.user = null
  selection.clearSelection()
  router.push({ name: 'login' })
})

export default router
